import { useEffect, useState } from 'react';

const MESSAGES = [
  'Reading your role…',
  'Looking at the curriculum…',
  'Picking what matters most…',
];
const STAGE_MS = 6000;

export function PlanLoadingCard() {
  const [stage, setStage] = useState(0);
  useEffect(() => {
    const t1 = setTimeout(() => setStage(1), STAGE_MS);
    const t2 = setTimeout(() => setStage(2), STAGE_MS * 2);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  return (
    <div
      style={{
        background: 'linear-gradient(135deg, rgba(13,40,24,1) 0%, rgba(10,31,18,1) 100%)',
        border: '1px solid rgba(79,233,181,0.32)',
        borderRadius: 12,
        padding: '40px 32px',
        marginBottom: 18,
        textAlign: 'center',
        minHeight: 220,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div className="pulse-dot" style={{ width: 14, height: 14, marginBottom: 24 }} />
      <div className="eyebrow" style={{ color: 'var(--color-accent)' }}>▌ Sonnet 4.6 is thinking</div>
      <h2
        aria-live="polite"
        style={{ fontSize: 22, fontWeight: 600, margin: '8px 0 4px', color: 'var(--color-text)' }}
      >
        {MESSAGES[stage]}
      </h2>
      <p style={{ color: 'var(--color-text-3)', fontSize: 13, margin: 0 }}>≈ 17 seconds total</p>

      <div style={{ width: '100%', maxWidth: 420, marginTop: 28, opacity: 0.5, display: 'flex', flexDirection: 'column', gap: 8 }}>
        <div style={{ height: 14, background: 'var(--color-bg-elevated)', borderRadius: 3, width: '80%' }} />
        <div style={{ height: 14, background: 'var(--color-bg-elevated)', borderRadius: 3, width: '60%' }} />
        <div style={{ height: 14, background: 'var(--color-bg-elevated)', borderRadius: 3, width: '70%' }} />
      </div>
    </div>
  );
}
